import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../../assets/images/logo.png";
import QR from "../../../../assets/images/qr.png";
import notConnectImg from "../../../../assets/images/notConnect.png";
import usbMonitor from "../../../../assets/images/usbMonitorBlue.png";
import styles from "./ScanQR.module.css";
import { Modal, SubmitButton, TextComponent } from "../../../../components";
import { PiSealCheck } from "react-icons/pi";
import Storage from "../../../../utills/AsyncStorage";
import { roles } from "../../../../config/roles";

const ScanQR = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [notConnectModal, setNotConnectModal] = useState(false);
  const [connectSuccessModal, setConnectSuccessModal] = useState(false);
  const { state } = useLocation();
  const role = Storage.getERole("@role");

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          {state == "usb inject" ? (
            <div className={styles.monitorDiv}>
              <img src={usbMonitor} style={{ width: "100%", height: "100%" }} />
            </div>
          ) : (
            <div className={styles.QRDiv}>
              <img src={QR} style={{ width: "100%", height: "100%" }} />
            </div>
          )}
          <TextComponent
            text={
              state == "usb inject"
                ? "Insert USB to register module"
                : "Align the QR code within the frame to scan the device"
            }
            className={styles.QRText}
          />
          <TextComponent
            text={"Phoenix Immobilizer Model X1"}
            className={styles.QRHeading}
          />
          <div className={styles.greyBox} style={{ width: "100%" }}>
            <TextComponent className={styles.greyBoxText1} text={"Device ID: "}>
              <text className={styles.greyBoxText2}>{"1234-5678-ABCD"}</text>
            </TextComponent>
          </div>
          <div className={styles.greyBox} style={{ width: "100%" }}>
            <TextComponent className={styles.greyBoxText1} text={"Status: "}>
              <text className={styles.statusBox}>{"● Drive"}</text>
            </TextComponent>
          </div>
          <div className={styles.twoGreyBox}>
            <div className={styles.greyBox} style={{ width: "49%" }}>
              <TextComponent
                className={styles.greyBoxText1}
                text={"Battery Life: "}
              >
                <text className={styles.greyBoxText2}>{"85%"}</text>
              </TextComponent>
            </div>
            <div className={styles.greyBox} style={{ width: "49%" }}>
              <TextComponent
                className={styles.greyBoxText1}
                text={"Firmware Version: "}
              >
                <text className={styles.greyBoxText2}>{"1.0.5"}</text>
              </TextComponent>
            </div>
          </div>
          <SubmitButton
            title={"Connect"}
            style={{ marginTop: "10px" }}
            onClick={() => setNotConnectModal(true)}
          />
        </div>
      </div>
      <Modal
        open={notConnectModal}
        onCancel={() => setNotConnectModal(false)}
        imageClass={styles.access_modalImg}
        icon={
          <div className={styles.notConnectimgDiv}>
            <img
              src={notConnectImg}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
        }
        title={"Unable to connect!"}
        width={"400px"}
        twoButton
        okBtnTitle={"Try Again"}
        cancelBtnTitle={"Contact support"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => setNotConnectModal(false)}
        onClickOkButton={() => {
          setNotConnectModal(false);
          !role || role == roles.user
            ? navigate("/addVehical")
            : setConnectSuccessModal(true);
        }}
      ></Modal>
      <Modal
        open={connectSuccessModal}
        onCancel={() => setConnectSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Modules registered successfully"}
        width={"400px"}
        buttonTitle={"View in Device Inventory"}
        onBtnPress={() => setConnectSuccessModal(false)}
        headingClass={styles.modalHeading}
      ></Modal>
    </div>
  );
};

export default ScanQR;
